import { pluginFactory } from '@atlaskit/editor-common/utils';
import { reducer } from './reducer';
import { ReplaceAroundStep, ReplaceStep } from '@atlaskit/editor-prosemirror/transform';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { regenerateSpellingDecorations, regenerateSelectedSpellingDecorations } from './decorations';
import { aiSpellingGrammarPluginKey } from './ai-spelling-grammar-plugin-key';
import { getAllProactiveAIBlocks, findProactiveAIBlockToUpdate } from './utils';
const handleDocChanged = (tr, pluginState, newEditorState) => {
  const {
    updatedProactiveAIBlock
  } = findProactiveAIBlockToUpdate(tr, pluginState, newEditorState);
  const {
    allDiffObjects,
    decorationSet
  } = pluginState;
  if ((allDiffObjects === null || allDiffObjects === void 0 ? void 0 : allDiffObjects.length) === 0) {
    return {
      ...pluginState,
      proactiveAIBlocks: updatedProactiveAIBlock
    };
  }
  let newAllDiffObjects = allDiffObjects || [];
  const isOverlappingPos = (pos, diffObject) => {
    const {
      from,
      to
    } = diffObject;
    if (pos >= from && pos <= to) {
      return true;
    }
    return false;
  };
  tr.steps.filter(step => step instanceof ReplaceStep || step instanceof ReplaceAroundStep).forEach(step => {
    newAllDiffObjects = newAllDiffObjects.filter(diffObject => !(isOverlappingPos(step.from, diffObject) || isOverlappingPos(step.to, diffObject)));
  });
  const nextPluginState = {
    ...pluginState,
    allDiffObjects: newAllDiffObjects.map(diffObject => ({
      ...diffObject,
      from: tr.mapping.map(diffObject.from),
      to: tr.mapping.map(diffObject.to)
    }))
  };

  // Update positions of diffObjects stored in blocks as well.
  const proactiveAIBlockWithPositionsUpdated = updatedProactiveAIBlock === null || updatedProactiveAIBlock === void 0 ? void 0 : updatedProactiveAIBlock.map(proactiveAIBlock => {
    if (proactiveAIBlock.diffObjects) {
      return {
        ...proactiveAIBlock,
        diffObjects: proactiveAIBlock.diffObjects.map(diffObject => ({
          ...diffObject,
          from: tr.mapping.map(diffObject.from),
          to: tr.mapping.map(diffObject.to)
        }))
      };
    }
    return proactiveAIBlock;
  });
  return {
    ...nextPluginState,
    decorationSet: regenerateSpellingDecorations({
      decorationSet,
      tr,
      pluginState: nextPluginState
    }),
    proactiveAIBlocks: proactiveAIBlockWithPositionsUpdated
  };
};
const handleSelectionChanged = (tr, pluginState) => {
  const {
    decorationSet
  } = pluginState;
  return {
    ...pluginState,
    decorationSet: regenerateSelectedSpellingDecorations({
      decorationSet,
      tr,
      pluginState
    })
  };
};
export const createInitialState = proactiveAIApiUrl => state => {
  return {
    proactiveAIBlocks: getAllProactiveAIBlocks(state),
    isSpellingAndGrammarEnabled: true,
    allDiffObjects: [],
    decorationSet: DecorationSet.empty,
    proactiveAIApiUrl,
    dismissedWords: new Set()
  };
};
export const {
  createPluginState,
  createCommand,
  getPluginState
} = pluginFactory(aiSpellingGrammarPluginKey, reducer, {
  mapping: (tr, pluginState) => {
    if (tr.docChanged) {
      var _pluginState$decorati;
      return {
        ...pluginState,
        decorationSet: (_pluginState$decorati = pluginState.decorationSet) === null || _pluginState$decorati === void 0 ? void 0 : _pluginState$decorati.map(tr.mapping, tr.doc)
      };
    }
    return pluginState;
  },
  onDocChanged: handleDocChanged,
  onSelectionChanged: handleSelectionChanged
});